import classNames from 'classnames';
import * as React from 'react';
import { useDeviceCondition } from '../../hooks';
import { AutoProlongContainer } from '../AutoProlong';
import { SubagentNotEnoughMoneyModalContainer } from '../SubagentNotEnoughMoneyModal';
import * as styles from './Checkout.css';
import { DetailContainer, TotalAmountContainer } from './components';
import { ICheckoutProps } from './types';
import { UIText2 } from '@cian/ui-kit';

export const Checkout = (props: ICheckoutProps) => {
  const { details, isAutoProlongVisible, autoProlongTooltipText } = props;

  const rootStyle = useDeviceCondition(styles['desktop'], styles['mobile']);

  return (
    <div className={classNames(rootStyle, styles['wrapper'])}>
      {Boolean(details.length) && (
        <div>
          {details.map((_, index) => (
            <DetailContainer index={index} key={index} />
          ))}
        </div>
      )}

      {isAutoProlongVisible && (
        <div className={styles['autoprolong']}>
          <AutoProlongContainer />
        </div>
      )}

      {!isAutoProlongVisible && autoProlongTooltipText && (
        <div className={styles['autoprolong-text']}>
          <UIText2>{autoProlongTooltipText}</UIText2>
        </div>
      )}

      <div className={styles['total']}>
        <TotalAmountContainer />
      </div>

      <SubagentNotEnoughMoneyModalContainer />
    </div>
  );
};
